import { isValidProductId } from "./product-utils";
import qs from "query-string";
import pick from "lodash/pick";
import omitBy from "lodash/omitBy";
import isNil from "lodash/isNil";

export const GQL_PDP_URL_PARAMS_ERROR =
  "GraphQL Params Error - No productId, category and unifiedId found in url";

/**
 * Parses product data from a URL OR a path of a specific format, i.e., `https://shop.lululemon.com/p2/mens-ss-tops/Metal-Vent-Tech-Polo-Two/_/prod4030048?color=55319`
 * @param {string} url
 * @param {string} queryString
 * @returns {object}
 *
 * @todo: url and query params are parsed by NextJS; those values should be used instead of adhoc string parsing
 */

export const getGQLProductParams = (
  url = "",
  queryString,
  acceptableUrlParams
) => {
  const parsedParams = qs.parse(queryString || "");
  const acceptableQueryParams = acceptableUrlParams
    ? pick(parsedParams, acceptableUrlParams)
    : parsedParams;
  const { locale, sl, forceMemberCheck } = acceptableQueryParams;

  // TODO - use URL or refine params, the text manipulation is an anti-pattern.
  try {
    const [category = "", unifiedId = "", _productId = ""] =
      url
        ?.trim()
        ?.split("?")[0] // remove query string
        ?.split(/\/[pd]\//)[1] // split on the `/p` or p2 or d (direct entry) url param
        ?.replace("/_", "") // remove the `/_` as there's no value
        ?.split("/") ?? // split remaining into an array
      []; // ...but default in case the earlier optional chains failed

    const productId = isValidProductId(_productId) ? _productId : "";

    if (!category && !productId && !unifiedId) {
      throw new Error(GQL_PDP_URL_PARAMS_ERROR);
    }

    return omitBy(
      {
        category,
        productId,
        unifiedId,
        locale,
        forceMemberCheck,
        sl,
      },
      isNil
    );
  } catch (ex) {
    throw ex;
  }
};

export const makeGetGQLProductParams =
  (acceptableUrlParams) => (fetchUrl, queryString) =>
    getGQLProductParams(fetchUrl, queryString, acceptableUrlParams);
